import React from 'react';
import { getBEMClasses } from 'apex-web/lib/helpers/cssClassesHelper';
import ProductIconContainer from 'apex-web/lib/components/common/ProductIcon/ProductIconContainer';

import './BalanceItem.css';
import { formatNumberToLocale } from '../../helpers/numberFormatter';

const balanceItemClasses = getBEMClasses('balance-item');

const BalanceItemComponent = props => {
  return (
    <div className={balanceItemClasses('container')}>
      <div className={balanceItemClasses('group')}>
        <div className={balanceItemClasses('icon')}>
          <ProductIconContainer
            iconFileName={props.balance.iconFileName}
            size={24}
          />
        </div>
        <div className={balanceItemClasses('product')}>
          {props.balance.Product + ' ' + props.balance.ProductFullName}
        </div>
      </div>
      <div className={balanceItemClasses('group')}>
        <div className={balanceItemClasses('position')}>
          <span>{props.balance.Amount}</span>
          {props.balance.Amount !== '-' && (
            <span className={balanceItemClasses('position-usd')}>
              {formatNumberToLocale(props.balance.NotionalValue, 2)} USD
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default BalanceItemComponent;
